export default "__VITE_ASSET__BJ68$241__"